if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 768px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          this.setActiveMedia(mediaToSwitch.dataset.target, false);
        });
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      this.syncMobileViewerHeight();
      this.mql.addEventListener('change', () => this.syncMobileViewerHeight());
    }

    syncMobileViewerHeight(activeMedia = null) {
      const viewer = this.elements.viewer;
      const slider = viewer?.querySelector('[id^="Slider-Gallery"]') || viewer?.slider;
      if (!viewer || !slider) return;

      const isMobileThumbnailGallery = !this.mql.matches && this.closest('.mobileshowthumb');
      if (!isMobileThumbnailGallery) {
        viewer.style.height = '';
        viewer.style.overflow = '';
        viewer.style.transition = '';
        slider.style.height = '';
        slider.style.overflowY = '';
        slider.style.alignItems = '';
        if (this.mobileHeightObserver) this.mobileHeightObserver.disconnect();
        return;
      }

      const media =
        activeMedia ||
        slider.querySelector('.product__media-item.is-active') ||
        slider.querySelector('.product__media-item');
      if (!media) return;

      const mediaContainer = media.querySelector('.product-media-container');
      if (!mediaContainer) return;

      const applyHeight = () => {
        const mediaStyle = window.getComputedStyle(media);
        const extraHeight =
          (parseFloat(mediaStyle.paddingTop) || 0) +
          (parseFloat(mediaStyle.paddingBottom) || 0);
        const mediaHeight = mediaContainer.getBoundingClientRect().height;
        const targetHeight = Math.ceil(mediaHeight + extraHeight);

        if (targetHeight > 0) {
          viewer.style.height = `${targetHeight}px`;
          viewer.style.overflow = 'hidden';
          viewer.style.transition = 'height 180ms ease';
          slider.style.height = `${targetHeight}px`;
          slider.style.overflowY = 'hidden';
          slider.style.alignItems = 'flex-start';
        }
      };

      applyHeight();
      window.requestAnimationFrame(applyHeight);
      window.setTimeout(applyHeight, 80);

      const image = mediaContainer.querySelector('img');
      if (image && !image.complete) {
        image.addEventListener('load', applyHeight, { once: true });
      }

      if (this.mobileHeightObserver) this.mobileHeightObserver.disconnect();
      if ('ResizeObserver' in window) {
        this.mobileHeightObserver = new ResizeObserver(applyHeight);
        this.mobileHeightObserver.observe(mediaContainer);
      }
    }

    onSlideChanged(event) {
      if (event.detail.currentElement) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
        this.syncMobileViewerHeight(event.detail.currentElement);
      }
    }

    setActiveMedia(mediaId, prepend, skipPageScroll = false) {
      const activeMedia =
      this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
      this.elements.viewer.querySelector('[data-media-id]');
      if (!activeMedia) {
        return;
      }
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia?.classList?.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          if (!skipPageScroll && this.dataset.quick != 'quickv') {
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      this.playActiveMedia(activeMedia);
      this.syncMobileViewerHeight(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
